<template>
    <div>
        <br />
        <h2>Product Stock Management</h2>
        <b-card>
            Show Product Stock Management Here
            <br/>
            </b-card>
            <br/>
            <b-button variant="outline-info"  v-on:click="showWizard()">Allocate Stock</b-button>
        <b-modal
            size="xl"
            header-bg-variant="light"
            header-text-variant="dark"
            ref="StockWizard"
            id="StockWizard"
            title="Product Stock Allocation"
            hide-footer>
            <b-card>
            <StockWizard @WizardComplete="FinishWizard" />
            </b-card>

        </b-modal>
      
    </div>
          
</template>
<script>
    import StockWizard from "@/components/StockComponents/StockWizard.vue";
    export default {
    computed: {},
    components: {
        StockWizard,
    },
    methods:{
        showWizard(){
            this.$refs["StockWizard"].show();
        },
        FinishWizard(){
            this.$refs["StockWizard"].hide();
            alert("DO what needs done here")
        }
    }

    }
</script>
        
<style>
        
</style>